import "../sass/child-styles.scss"

import CollapseMobileMenu from './modules/CollapseMobileMenu';

const collapseMobileMenu = new CollapseMobileMenu();


/* Digital Brochure Navigation Bar */

jQuery(document).ready(function ($) {
    $('.nav-arrow, .nav-title').click(function () {
      // Remove 'active' and 'rotate' from all nav items
      $('.wp-block-group').removeClass('active rotate');
  
      // Add 'active' and 'rotate' to this nav item's parent group
      $(this).closest('.wp-block-group').addClass('active rotate');
    });
});

/*
jQuery(document).ready(function ($) {
    $('.brochure-start').click(function (e) {
      e.preventDefault();
  
      // Remove 'active' and 'rotate' from all nav items
      $('.side-nav-bar .wp-block-group').removeClass('active rotate');
  
      // Add 'active' and 'rotate' to the second nav item
      $('.side-nav-bar .wp-block-group:eq(0)').addClass('active rotate');
  
      // Smooth scroll to #Introduction section
      $('html, body').animate({
        scrollTop: $($(this).find('.wp-block-boldblocks-svg-block__inner').attr('href')).offset().top,
      }, 500);
    });
});
*/
jQuery(document).ready(function ($) {
  $('.brochure-start').click(function (e) {
    e.preventDefault();

    // Remove 'active' and 'rotate' from all nav items
    $('.side-nav-bar .wp-block-group').removeClass('active rotate');

    // Add 'active' and 'rotate' to the second nav item
    $('.side-nav-bar .wp-block-group:eq(0)').addClass('active rotate');

    // Smooth scroll to #Introduction section
    var href = $($(this).find('.wp-block-boldblocks-svg-block__inner')).attr('href');
    
    if (href.startsWith('#')) {  // Check if the href is a valid ID selector 
        $('html, body').animate({
            scrollTop: $(href).offset().top,
        }, 500);
    }
  });
});


// Scrolling event
jQuery(document).ready(function ($) {
  var sections = $('.wp-block-group').map(function () {
      var href = $(this).find('a').first().attr('href');
      if (href.startsWith('#')) {  // Check if the href is a valid ID selector 
          return $(href);
      }
  }).get();

  $(window).on('scroll', function () {
      // Remove 'active' and 'rotate' from all nav items
      $('.wp-block-group').removeClass('active rotate');

      for (var i = 0; i < sections.length; i++) { 
          if(sections[i] !== undefined) { 
              var sectionTop = sections[i].offset().top;
              var sectionBottom = sectionTop + sections[i].height();

              if ($(window).scrollTop() >= sectionTop && $(window).scrollTop() <= sectionBottom) { 
                  $('.wp-block-group:eq('+i+')').addClass('active rotate');   
                  break;
              }
          }
      }
  });
});


/* Smooth Scroll for <a> tags with hash(#) herfs */
jQuery(document).ready(function($) {
  $('a[href^="#"]').on('click', function(e) {
      e.preventDefault();

      var target = this.hash;
      var $target = $(target);

      $('html, body').stop().animate({
          'scrollTop': $target.offset().top
      }, 900, 'swing', function() {
          window.location.hash = target;
      });
  });
});


/* Glide Carousel */
import Glide from '@glidejs/glide';

document.addEventListener('DOMContentLoaded', function() {
  new Glide('.glide').mount();
});

new Glide('.glide').mount();


/* Mobile navigation submenu toggle functionality */
/*
document.addEventListener("DOMContentLoaded", function() {
  const toggleButtons = document.querySelectorAll(".wp-block-navigation-submenu__toggle");

  if (toggleButtons) {
      toggleButtons.forEach((button) => {
          button.addEventListener("click", function() {
              let submenu = this.nextElementSibling;

              if (submenu) {
                  submenu.classList.toggle("show");
              }
          });
      });
  }
});
*/